import { ContentPanel } from "../components/home/content-panel";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function Main() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title={"Powering creation together."}
          desc={
            <>
              Marketing tools makes it easier for individuals & teams to achieve their collective
              goals, create professional marketing branded assets and stay
              informed with features across our projects
            </>
          }
          height={"h-[33rem]"}
          logoWidth={"w-10/12"}
        />
        <ContentPanel />
      </div>
    </MainLayout>
  );
}

export default Main;
